const ROOMS = {
  '2bhk': [
    'master bedroom',
    'home office/study',
    "parent's",
    "kid's bedroom",
    "kid's room 1",
    "kid's room 2",
    'guest bedroom',
  ],
  '3bhk': [
    'master bedroom',
    'home office/study',
    "kid's room 1",
    "kid's room 2",
    'guest',
    'entertainment/den',
    "parent's",
    "kid's bedroom",
  ],
  '3.5bhk': ['master bedroom', "kid's room 1", "kid's room 2", 'guest', "kid's bedroom"],
  '4bhk': [
    'master bedroom',
    'home office/study',
    "kid's room 1",
    "kid's room 2",
    'guest',
    'entertainment/den',
    "parent's",
    "kid's bedroom",
  ],
};

const MAX_ROOMS_ALLOWED_IN_LAYOUT = {
  '2bhk': 2,
  '3bhk': 3,
  '3.5bhk': 4,
  '4bhk': 4,
};

const APARTMENT_TYPES = ['2bhk', '3bhk', '3.5bhk', '4bhk'];

export { ROOMS, MAX_ROOMS_ALLOWED_IN_LAYOUT, APARTMENT_TYPES };
